export default theme => ({
  passwordTip: {
    marginTop: 4,
    fontSize: 11,
    color: theme.grey2
  },
  password_rules: {
    fontSize: 11,
    color: theme.grey2,
    marginTop: 8
  },
  strengthBar: {
    display: 'flex',
    marginTop: 4
  },
  bar: {
    backgroundColor: theme.grey8,
    height: 5,
    flexBasis: '100%',
    '&:not(:last-child)': {
      marginRight: 2
    }
  },
  passwordField: {
    paddingTop: 5
  },
  confirmPasswordField: {
    paddingTop: 10
  },
  hiddenText: {
    fontSize: 11,
    opacity: 0
  },
  redText: {
    fontSize: 11,
    color: theme.warningRed
  },
  orangeText: {
    fontSize: 11,
    color: theme.cautionOrangeDark
  },
  greenText: {
    fontSize: 11,
    color: theme.validGreenDark
  },
  greenBG: {
    backgroundColor: theme.validGreen
  },
  orangeBG: {
    backgroundColor: theme.cautionOrange
  },
  redBG: {
    backgroundColor: theme.warningRed
  },
  tooltipButton: {
    padding: 0,
    minWidth: 16,
    height: 16,
    lineHeight: '16px',
    fontSize: 11,
    borderRadius: '50%',
    marginLeft: 5,
    color: theme.indigo3,
    backgroundColor: 'transparent',
    border: `1px solid ${theme.indigo3} !important`,
    cursor: 'help',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  tooltipContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 4
  }
});
